class ProductSubscriptions extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="selling_plan"]');
    this.sellingPlanDisplay = this.querySelector('.selling-plan-display');
    this.initialise();
  }

  initialise() {
    // Auto-select the selling plan if it exists
    if (this.sellingPlanDisplay) {
      const sellingPlanId = this.sellingPlanDisplay.getAttribute('data-selling-plan-id');
      if (sellingPlanId && this.input) {
        this.input.value = sellingPlanId;
      }
    }
  }

  getCurrentSellingPlanId() {
    return this.input ? this.input.value : '';
  }

  hasActiveSellingPlan() {
    return this.getCurrentSellingPlanId() !== '';
  }
}

if (!customElements.get('product-subscriptions')) {
  customElements.define('product-subscriptions', ProductSubscriptions);
}

window.ProductSubscriptions = ProductSubscriptions;

window.getCurrentSellingPlanId = function () {
  const productSubscriptions = document.querySelector('product-subscriptions');
  return productSubscriptions ? productSubscriptions.getCurrentSellingPlanId() : '';
};

window.hasActiveSellingPlan = function () {
  const productSubscriptions = document.querySelector('product-subscriptions');
  return productSubscriptions ? productSubscriptions.hasActiveSellingPlan() : false;
};

class SellingPlanListener extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    // Listen for variant:change event when SellingPlanListener is added to DOM
    this.updateAddToCartText();
    document.addEventListener('variant:change', this.handleVariantChange);
  }

  disconnectedCallback() {
    // Clean up event listener when SellingPlanListener is removed
    document.removeEventListener('variant:change', this.handleVariantChange);
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;
    if (!variant) return;

    fetch(`${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`)
      .then(response => {
        return response.text();
      })
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const updated = html.getElementById(`${this.id}`);
        this.innerHTML = updated.innerHTML;
      })
      .catch(e => {
        console.error('SellingPlanListener', e);
      })
      .finally(this.updateAddToCartText);
  }

  updateAddToCartText() {
    const aSellingPlan = document.querySelector('.selling-plan-name');
    const addToCartText = document.querySelector('[data-add-to-cart-text]');
    if (aSellingPlan) {
      addToCartText.innerText = `${addToCartText.innerText}: ${aSellingPlan.innerText}`;
    }
  }
}

if (!customElements.get('selling-plan-listener')) {
  customElements.define('selling-plan-listener', SellingPlanListener);
}
